import { createContractRequest } from './helper';
export const getOfferBlob = createContractRequest({
    route: '/contract/offers/blob/:offerId',
    method: 'get',
    source: 'data',
});
